export default {
    'accessibility': {
        'navigation': {
            'header': 'Kopfzeile',
            'mainMenu': 'Navigation',
            'moreMenu': 'weitere Optionen',
            'mobileMenu': 'Mobile Navigation',
            'openMobileMenuButton': 'Mobile Navigations-Menü öffnen',
            'closeMobileMenuButton': 'Mobile Navigations-Menü schließen',
            'userMenu': 'Benutzer-Menü',
            'current': 'ausgewählt',
        }
    },
    'update': {
        'dialog': {
            'title': 'Neue Version verfügbar',
            'content': 'Beim Aktivieren wird das Ableseportal kurz neu geladen. Ihre bereits übermittelten Ablesungen bleiben dabei erhalten.',
            'buttonNegative': 'Später',
            'buttonPositive': 'Jetzt aktivieren'
        }
    },
    'login': {
        'title': 'Willkommen bei der Ablesung der {{applicationName}}',
        'subtitle': 'Bitte melden Sie sich mit den Zugangsdaten an, die Sie von uns erhalten haben:',
        'qrcode': {
            'error': {
                'access': {
                    'dialogtitle': 'Kamera Zugriff nicht möglich',
                    'title': 'Leider konnten wir nicht auf Ihre Kamera zugreifen.',
                    'text': 'Bitte melden Sie sich mit Ihren Zugangsdaten an.',
                },
                'device': {
                    'title': 'Die Anmeldung über die Kamera ist leider mit Ihrem Gerät nicht möglich - oder Sie haben uns keinen Zugriff auf die Kamera erlaubt.',
                },
            },
            'teaser': {
                'text': 'Sie haben einen QR-Code auf einer Ablesekarte oder in einem Brief erhalten? Und Sie haben eine Webcam?<1/> Dann scannen Sie einfach den QR-Code. So melden wir Sie schnell an:',
                'access': 'Für die Anmeldung mit QR-Code benötigen wir Zugriff auf Ihre Kamera.',
            },
            'dialog': {
                'hint': 'Halten Sie den QR-Code aus Ihrem Brief oder von Ihrer Ablesekarte in den Rahmen.',
                'searching': 'Suche QR-Code …',
                'checking': 'Anmeldung wird geprüft …',
                'invalid': 'Dieser QR-Code ist ungültig oder abgelaufen.',
                'foreign': 'Dieser QR-Code gehört nicht zur Ablesung.',
                'alternative': 'Lieber mit Zugangsdaten anmelden',
            },
            'buttons': {
                'login': 'Mit QR-Code anmelden',
                'close': 'Schließen',
            },
        },
        'labels': {
            'username': 'Benutzername',
            'password': 'Passwort',
            'qr-login': 'QR-Code Anmeldung',
        },
        'placeholders': {
            'username': 'Mein Benutzername',
            'password': 'Passwort',
        },
        'buttons': {
            'login': 'Anmelden',
        },
        'tabs': { // todo: remove when known where to implement unknownUserReading
          'login': 'Anmelden mit Zugangsdaten',
          'unknownUserReading': 'Ablesen ohne Zugangsdaten'
        },
        'error': {
            'login': {
                'text': 'Anmeldung fehlgeschlagen. Bitte prüfen Sie Ihre Anmeldedaten.',
            },
            'dialog': {
                'title': 'Anmeldung nicht möglich',
                'description': 'Tut mir leid, die Anmeldung mit diesen Zugangsdaten ist momentan nicht möglich.',
                'content': 'Wenn Sie eine Ablesekarte erhalten haben, wurden die Daten der Karte vielleicht noch nicht übermittelt.<1 /><2 />Probieren Sie es später noch einmal.',
                'buttons': {
                    'close': 'Schließen',
                    'unknownUserReading': 'Ablesung ohne Anmeldung'
                },
                'unknownUserReading': 'Alternativ können Sie hier Ihren Zählerstand ohne Anmeldung übermitteln:',

            },
        },
        'usage': {
            'text': 'Diese Seite wird von {{applicationName}} bereitgestellt. Mit der Anmeldung und Nutzung erklären Sie sich mit den <3>Datenschutzbedingungen</3> einverstanden.',
        },
    },
    'unknownUserReading': {
        'screenTitle': 'Zählerstand mitteilen',

        'loginScreen': {
            'text': 'Sie möchten uns einen Zählerstand mitteilen, haben aber keinen Brief von uns erhalten?',
            'buttonText': 'Ablesung ohne Zugang'
        },
        'doneScreen': {
            'title': 'Ihre Ablesung ist erledigt',
            'message': 'Vielen Dank. Ihr Zählerstand wurde erfolgreich übermittelt.'
        },

        'errorHandling': {
            'isAuthPending':'Sie werden angemeldet, bitte warten.',
            'isAuthError': 'Fehler beim Anmelden. Versuchen Sie es bitte später erneut.',
            'tokenExpired': 'Ihre Sitzung ist abgelaufen, Bitte melden Sie sich erneut an.',
            'featureNotAvailable': 'Das Ablesen ohne Zugangsdaten ist aktuell nicht möglich. Versuchen Sie es bitte später erneut.',
        },
        'featureTitle': 'Zählerstand mitteilen',
        'introduction': {
            // 'title': 'Ihre Zählerablesung',
            'screenHint': 'Sie können uns Ihren Zählerstand auch ohne Anmeldung mitteilen.',
            'pinReceivedHint': 'Wenn Sie Zugangsdaten per Brief oder eine Ablesekarte von unserem Ableser erhalten haben, dann melden Sie sich bitte hier an:'
        },
        'meterStep': {
            'title': 'Zähler auswählen',
            'description': 'Bitte geben Sie zunächst Ihre Zählernummer ein und wählen die Art Ihres Zählers aus.',
            'validationError': 'Bitte geben Sie die Zählernummer vollständig an.'
        },
        'meterReadingStep': {
            'title': 'Ablesung durchführen',
            'description': 'Bitte tragen Sie nun die Zählerstände Ihres Zählers <1>{{preposition}} Nachkommastellen</1> ein.',
            'validationError': 'Bitte geben Sie die Zählerstände vollständig an.'
        },
        'contactStep': {
            'title': 'Kontaktdaten angeben',
            'description': 'Damit wir Ihre Angaben korrekt zuordnen können, benötigen wir Ihre Kontaktdaten und die Adresse des Zählers.',
            'validationError': 'Bitte geben Sie alle Pflichtfelder (*) an.',
            'meterReadingZIPCodeValidation': {
                'title': 'Zählerstand nicht erfassbar',
                'content': 'Dieser Zähler liegt nicht in unserem Gebiet. Deshalb können wir den Zählerstand nicht annehmen. Bitte melden Sie den Stand direkt Ihrem zuständigen Messstellenbetreiber. Vielen Dank für Ihr Verständnis!',
            },
        },
        'summaryStep': {
            'title': 'Zusammenfassung',
            'description': 'Bitte prüfen Sie abschließend Ihre Daten'
        },
        'information': {
            'meterNumberHint': 'Für die korrekte Zuordnung Ihrer Ablesung benötigen wir die vollständige Zählernummer.',
            'emailProcessing': 'Hinweis: Die Nutzung der E-Mail-Funktion erfolgt freiwillig. Die E-Mail-Adresse wird ohne Ihre Zustimmung nicht dauerhaft gespeichert.',
            'privacyPolicy': 'Diese Seite wird von {{applicationName}} bereitgestellt. Ich habe die <3>Datenschutzbedingungen</3> gemäß Art. 13 und 14 DS-GVO zur Kenntnis genommen.',
        },
        'notification': {
            'readingRequest': {
                'error': {
                    'title': 'Mitteilung fehlgeschlagen',
                    'description': 'Der Zählerstand konnte nicht übermittelt werden. Versuchen Sie es bitte später erneut.',
                },
                'success': {
                    'title': 'Zählerstand mitgeteilt',
                    'description': 'Der Zählerstand wurde erfolgreich übermittelt.',
                }
            },
            'readingReceipt': {
                'error': {
                    'title': 'Kopie per E-Mail fehlgeschlagen',
                    'description': 'Eine Kopie Ihrer Zählerstände konnte an Ihre angegebene E-Mail nicht versendet werden.',
                },
                'success': {
                    'title': 'Kopie per E-Mail versendet',
                    'description': 'Eine Kopie Ihrer Zählerstände wurde an Ihre angegebene E-Mail versendet.',
                }
            }
        },
        'subTitle': {
            'meterNumber': 'Zählernummer',
            'meterType': 'Zählerart',
            'meterSubType': 'Unterart',
            'meterReading': 'Ihre Zählerstände',
            'readingDate': 'Ablesedatum',
            'contact': 'Ihre Kontaktdaten',
            'meterAddress': 'Adresse des Zählers',
            'readingReason': 'Grund der Ablesung',
            'meter': 'Ihr Zähler',
            'readingValues': 'Ablesewerte',
            'email': 'Sie möchten eine Kopie Ihrer Zählerstände per E-Mail?',
            'privacyPolicy': 'Datenschutzerklärung',
        },
        'description': {
            'readingDate': 'Wann haben Sie den Zählerstand erfasst?',
            'dataPrivacyRequired': 'Bitte stimmen Sie der Datenschutzerklärung zu. Erst dann können wir Ihre Daten speichern.',
        },
        'label': {
            'meterNumber': 'Zählernummer',
            'meterType': 'Zählerart',
            'meterSubType': 'Unterart',
            'queryTransformerOrMWhPostDecimals': 'Nachkommastellen für Wandler- oder MWh-Messung erfassen',
            'contact': 'Kontaktdaten',
            'firstname': 'Vorname',
            'lastname': 'Nachname',
            'meterAddress': 'Adresse des Zählers',
            'street': 'Straße',
            'houseNumber': 'Hausnummer',
            'zip': 'Postleitzahl',
            'city': 'Stadt',
            'readingReason': 'Grund der Ablesung',
            'readingDate': 'Ablesedatum',
            'email': 'E-Mail Adresse'
        },
        'placeholder': {
            'meterNumber': 'Zählernummer',
            'firstname': 'Vorname',
            'lastname': 'Nachname',
            'street': 'Straße',
            'houseNumber': 'Hausnummer',
            'zip': 'PLZ',
            'city': 'Stadt',
            'email': 'E-Mail',
        },
        'meterType': {
            'ELECTRIC_METER': 'Stromzähler',
            'GAS_METER': 'Gaszähler',
            'WATER_METER': 'Wasserzähler',
            'WATER_WARM_METER': 'Warmwasserzähler',
            'HEAT_METER': 'Wärmezähler',
        },
        'meterSubType': {
            'ELECTRIC_METER_TARIFFS_ONE': 'Stromzähler (1 Tarif)',
            'ELECTRIC_METER_TARIFFS_TWO': 'Stromzähler (2 Tarife)',
            'ELECTRIC_METER_FEED_IN_METER': 'Stromzähler (Einspeiser)',
            'OTHER': 'anderer'
        },
        'readingReason': {
            'ANNUAL_READING': 'Jahresablesung',
            'CONTROL_READING': 'Kontrollablesung',
            'PROVIDER_CHANGE': 'Lieferantenwechsel / Umzug',
        },
        'rateName': {
            'Verbrauch': 'Verbrauch',
            'Einspeisung': 'Einspeisung',
        },
        'button': {
            'refreshToken': 'Erneut anmelden',
            'toHome': 'Zur Startseite zurückkehren',
            'removeMeterRate': 'Tarif entfernen',
            'loginWithPIN': 'mit Zugangsdaten anmelden',
            'forceContinue': 'Trotzdem übermitteln',
            'continue': 'Weiter',
            'submit': 'Ablesedaten senden'
        },
        'preposition': {
            'with': 'mit',
            'without': 'ohne'
        },
    },
    'home': {
        'title': 'Mein Ableseportal - {{applicationName}}',
        'introduction': {
            'title': 'Willkommen',
            'reading': 'Ihre Zähler finden Sie im Menü <1>$t(menu.reading)</1>. Dort können Sie schnell & einfach Zählerstände eintragen und abschicken.',
            'management': 'Über den Menüpunkt <1>$t(menu.management)</1> können Sie Ablesungen mit anderen teilen. Als Hausverwaltung teilen Sie z.B. Ablesungen mit Ihrem Hausverwalter oder den Hausmeistern.',
        },
        'account': {
            'title': 'Mein Zugang',
            'title_other': 'Meine Zugänge',
            'multipleAccounts': 'Sie haben sich mit mehreren Zugängen angemeldet:',
            'login': {
                'info': 'Sie sind mit dem Zugang <1>{{name}}</1> angemeldet.',
                'parent': 'Dieser Zugang wurde von <1>{{parent}}</1> für Sie erstellt.',
                'shared': 'von {{parent}} mit Ihnen geteilt',
            },
        },
        'readings': {
            'title': 'Meine Ablesungen',
            'open': 'Sie haben <1>{{jobCountOpen}} offene</1> Ablesung.',
            'open_other': 'Sie haben <1>{{jobCountOpen}} offene</1> Ablesungen.',
            'done': 'Sie haben alle Ablesungen erledigt!',
            'labels': {
                'totalReadings': 'Ablesungen gesamt',
                'progress': 'Fortschritt (erledigt)',
            },
            'buttons': {
                'openReadings': '$t(common.reading_other) öffnen',
                'aiReading': 'Ablese-Assistent starten',
            },
        },
    },
    'jobs': {
        'search': {
            'noResults': 'Wir haben nichts gefunden für <1/> <3>{{searchValue}}</3> <5/>.',
        },
        'labels': {
            'readingsDone': 'Erledigte $t(common.reading_other)',
        },
        'share': {
            'assignmentPresets': {
                'saveCheckbox': 'Diese Auswahl als Vorauswahl speichern',
                'modeNew': 'Neue Vorauswahl erstellen',
                'modeOverwrite': 'Bestehende Vorauswahl überschreiben',
                'nameLabel': 'Name der Vorauswahl',
                'selectExisting': 'Vorauswahl wählen',
                'emailLabel': 'E-Mail-Adressen für die Vorauswahl (optional)',
                'nameConflict': 'Es existiert bereits eine Vorauswahl mit diesem Namen.',
            },
            'title': 'Ablesung teilen',
            'placeholders': {
                'name': 'Hausverwaltung Müller',
                'email': 'max@example.com',
            },
            'descriptions': {
                'accessName': 'Geben Sie dem neuen Zugang einen Namen. Diesen Namen sehen Sie später in Ihrer Übersicht – zusammen mit dem Fortschritt der Ablesung. Auch der neue Zugang selbst sieht diesen Namen.',
                'reshareAllowed': 'Wenn Sie das einschalten, darf dieser Zugang die Zähler an weitere Personen weitergeben. Liest der Zugang die Zähler selbst ab, brauchen Sie das nicht.',
            },
            'defaultShareName': 'Zähler {{meterNumber}}',
            'defaultShareName_other': 'Zähler {{meterNumber}} u.a.',
            'labels': {
                'accessName': 'Zugangsname',
                'additionalOptions': 'Zusätzliche Optionen',
                'reshareAllowed': 'Darf weiterteilen',
                'accessEmail': 'E-Mails vom Zugang',
                'username': 'Benutzername',
                'password': 'Passwort',
                'tokenLogin': 'Direkt-Link',
                'webLogin': 'Webportal-URL',
                'qrcode': 'QR Code',
            },
            'sending': 'Teile Ablesungen...',
            'success': {
                'summary': 'Der Zugang "{{name}}" wurde erfolgreich erstellt und beinhaltet {{count}} Zähler.',
                'summary_other': 'Der Zugang "{{name}}" wurde erfolgreich erstellt und beinhaltet {{count}} Zähler.',
                'message': 'Sie können die nachfolgenden Anmeldedaten für diesen Zugang nun weitergeben.',
                'loginMethod': {
                    'email': {
                        'title': 'Zugang per E-Mail versenden',
                        'description':
                            'Sie können die Anmeldedaten direkt an die E-Mail-Adressen des Zugangs versenden.',
                        'notifications': {
                            'valid': 'Die von Ihnen angegebenen E-Mail-Adressen sind gültig.',
                            'warning': 'Die von Ihnen angegebenen E-Mail-Adressen sind nicht gültig!',
                        },
                        'send' : 'Die Zugangsdaten wurden an {{email}} versendet.'
                    },
                    'triggerText': 'weitere Anmeldeoptionen anzeigen',
                    'direct': {
                        'title': 'Direkt-Anmeldung per Link',
                        'description': 'Der Link zur Direkt-Anmeldung beinhaltet bereits die Zugangsdaten.'
                    },
                    'web': {
                        'title': 'Manuelle Anmeldung per Login',
                        'description': 'Optional können Sie die folgenden Anmeldedaten zur manuellen Anmeldung weitergeben.',
                    },
                },
            },
            'buttons': {
                'createAccess': 'Zugang erstellen',
                'copyTokenUrl': 'Zugangs-URL kopieren',
                'send': 'Senden',
                'close': 'Schließen',
            },
        },
        'details': {
            'meloAttribute': {
                'sectionAria': 'Zusätzliche Angaben zum Zähler bzw. Zählpunkt',
                'sectionTitle': 'Meine Notizen',
                'addAria': 'Notiz hinzufügen',
                'addLabel': 'Notiz',
                'editAria': 'Notiz bearbeiten',
                'valueLabel': 'Notiz',
                'save': 'Speichern',
                'cancel': 'Abbrechen',
                'delete': 'Löschen',
                'dialog': {
                    'addTitle': 'Notiz hinzufügen',
                    'editTitle': 'Notiz bearbeiten',
                    'description': 'Diese persönliche Notiz wird für den Zähler bzw. Zählpunkt hinterlegt und steht Ihnen bei der nächsten Ablesung wieder zur Verfügung.',
                },
                'deleteConfirm': {
                    'title': 'Notiz löschen',
                    'content': 'Möchten Sie diese Notiz wirklich löschen?',
                    'ok': 'Löschen',
                    'cancel': 'Abbrechen',
                },
                'errors': {
                    'conflict': 'Notiz konnte nicht gespeichert werden (z. B. Höchstzahl erreicht oder für diesen Zähler bzw. Zählpunkt nicht möglich).',
                    'stale': 'Die Notiz wurde zwischenzeitlich geändert. Bitte laden Sie die Seite neu, um die aktuelle Fassung zu sehen.',
                    'generic': 'Die Notiz konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.',
                },
                'keys': {
                    'NOTE': 'Notiz',
                },
            },
            'title': 'Ableseauftrag',
            'successTitle': 'Ablesung erfolgreich übermittelt',
            'successDescriptionOtherJobs': 'Sie können jetzt weitere Ablesungen durchführen.',
            'successDescriptionAllDone': 'Sie haben alle Zähler erfolgreich abgelesen.',
            'successDescriptionThankYou': 'Vielen Dank!',
            'pendingSuccessTitle': 'Ablesung erfasst – Senden, sobald online',
            'pendingSuccessHint': 'Sie sind gerade offline. Ihre Ablesung ist erfasst und wird automatisch gesendet, sobald wieder eine Internetverbindung besteht. Bleiben Sie dafür am besten im Ableseportal.',
            'pendingSuccessHintOtherJobs': 'In der Zwischenzeit können Sie weitere Zähler ablesen.',
            'doneHint': '<0>Dieser Zähler wurde bereits abgelesen.</0><1/> Sie können den Zählerstand korrigieren und uns einen neuen Stand schicken.',
            'doneHintLate': '<0>Dieser Zähler wurde bereits abgelesen.</0><1/> Sie können den Zählerstand korrigieren und uns einen neuen Stand schicken.',
            'doneHintOverdue': '<0>Dieser Zähler wurde bereits abgelesen.</0><1/> Sie können den Zählerstand korrigieren und uns einen neuen Stand schicken.',
            'sending': 'Sende Daten...',
            'multiObisWarning': 'Dieser Zähler hat <1 className=\'font-medium\'>{{meterRateCount}} Tarife</1>: Bitte tragen Sie jeden Wert beim richtigen Tarif ein!',
            'send': {
                'confirm': 'Trotzdem senden',
                'cancel': 'Korrigieren',
            },
            'unsavedChanges': {
                'title': 'Eingaben verwerfen?',
                'content': 'Ihre Eingaben wurden noch nicht übermittelt. Wenn Sie diese Seite jetzt verlassen, gehen die erfassten Daten verloren.',
                'confirm': 'Eingaben verwerfen',
                'cancel': 'Weiter bearbeiten',
            },
            'labels': {
                'meterNumber': '$t(meterReadingJob.meterNumber)',
                'maLoId': '$t(meterReadingJob.maLoId)',
                'meterType': 'Zählerart',
                'customer': '$t(meterReadingJob.customer.title)',
                'customerNumber': '$t(meterReadingJob.customer.customernumber)',
                'deliveryPoint': 'Adresse',
                'readingValue': 'Ablesewert',
                'reading': '$t(common.reading)',
                'readingImage': 'Ablesefoto',
                'partner': 'Vertragspartner',
                'objectKey': 'Objektschlüssel',
                'locationDescription': 'Beschreibung',
                'hint': 'Hinweis',
                'obis': 'Tarif',
                'readingDate': 'Ablesedatum',
                'readingHint': 'Ablesehinweis',
                'targetReadingDate': '$t(common.targetReadingDate)',
                'meterRateTaskReadingImages': 'Ablesefotos',
                'meterRateTaskReadingComment': 'Ablesehinweis',
                'aiReading': 'KI Ablesung',
            },
            'readingHint': {
                'placeholder': 'Kein Hinweis',
                'meterChanged': 'Zähler gewechselt',
                'freetext': {
                    'label': 'anderer Hinweis',
                    'placeholder': 'Hinweis zur Ablesung...',
                },
            },
            'warnings': {
                'constraints': {
                    'beforeEarliestExecution': {
                        'title': 'Ablesezeitraum hat noch nicht begonnen',
                        'description': 'Wir haben den Zählerstand ab dem <1>{{earliestExecution}}</1> angefragt.<br/> Sie können den Zähler trotzdem ablesen. Es kann aber sein, dass wir Ihren Verbrauch schätzen.',
                    },
                    'afterLatestExecution': {
                        'title': 'Ablesezeitraum ist überschritten',
                        'description': 'Wir haben den Zählerstand bis zum <1>{{latestExecution}}</1> angefragt.<br/> Sie können den Zähler trotzdem ablesen. Es kann aber sein, dass wir den Stand nicht mehr für die Abrechnung verwenden können.',
                    },
                    'beforeSendingReadingValuesIsAllowedBasedOnEarliestExecutionAndDuration': {
                        'title': 'Ablesezeitraum hat noch nicht begonnen',
                        'description': 'Sie können den Zählerstand erst ab dem <1>{{earliestExecution}}</1> senden.<br/> Bei Fragen wenden Sie sich bitte an den Kundenservice.'
                    },
                    'afterSendingReadingValuesIsAllowedBasedOnLatestExecutionAndDuration': {
                        'title': 'Ablesezeitraum ist überschritten',
                        'description': 'Sie können den Zählerstand leider nicht mehr senden. Der Ablesezeitraum ist vorbei.<br/> Bei Fragen wenden Sie sich bitte an den Kundenservice.'
                    },
                },
                'check': {
                    'title': 'Bitte Eingabe prüfen',
                    'message': 'Bitte prüfen Sie die eingegebenen Zählerstände noch einmal.',
                    'details': 'Bitte prüfen Sie: Haben Sie die richtige Anzahl an Nachkommastellen abgelesen? Und sind Sie nicht aus Versehen mit dem Komma verrutscht?',
                },
                'incomplete': {
                    'title': 'Unvollständige Werte',
                    'message': 'Ihr Zähler hat mehrere Tarife. Sie haben aber nur für einen Teil Werte eingetragen.',
                    'details': 'Für eine korrekte Abrechnung braucht Ihr Anbieter meist alle Zählerstände. Fehlt ein Stand, wird er oft geschätzt.',
                },
                'invalidText': 'Bitte exakt {{count}} Nachkommastelle angeben.',
                'invalidText_other': 'Bitte exakt {{count}} Nachkommastellen angeben.',
                'validationWarningText': 'Der Zählerstand ist nicht plausibel, bitte prüfen Sie die Eingabe.',
                'historicValidationWarningText': 'Der Zählerstand ist nicht plausibel, der Wert ist geringer als bei der letzten Ablesung.',
                // fixme: is not processed | 'historicValidationErrorText': 'Der Zählerstand ist nicht plausibel, der Wert ist geringer als bei der letzten Ablesung. Bitte fügen Sie ein Ablesefoto oder einen Ablesehinweis hinzu.',
                'historicValidationFeedInMeterWarningText': 'Der Zählerstand ist nicht plausibel, der Wert ist geringer als bei der letzten Ablesung.',
                'continuousReadingsValidationWarningText': 'Der Zählerstand ist nicht plausibel, der Wert ist geringer als bei der letzten Ablesung.',
                'continuousValidationImageRequiredError': 'Der Zählerstand ist niedriger als der zuvor abgelesene Wert. Bitte fügen Sie ein Ablesefoto hinzu.',
                'continuousValidationImageOrCommentRequiredError': 'Der Zählerstand ist niedriger als der zuvor abgelesene Wert. Bitte fügen Sie ein Ablesefoto oder einen Ablesehinweis hinzu.',
                'imageRequiredError': 'Der Zählerstand ist nicht plausibel. Bitte fügen Sie ein Ablesefoto hinzu.',
                'imageOrCommentRequiredError': 'Der Zählerstand ist nicht plausibel. Bitte fügen Sie ein Ablesefoto oder einen Ablesehinweis hinzu.',
                // fixme: is not processed | 'imageAndCommentRequiredError': 'Der Zählerstand ist nicht plausibel. Bitte fügen Sie ein Ablesefoto und einen Ablesehinweis hinzu.',
                'imageRequiredFeedInMeterError': 'Der Zählerstand ist nicht plausibel. Bitte fügen Sie ein Ablesefoto hinzu.',
                'imageOrCommentRequiredFeedInMeterError': 'Der Zählerstand ist nicht plausibel. Bitte fügen Sie ein Ablesefoto oder einen Ablesehinweis hinzu.',
                // fixme: is not processed | 'imageAndCommentRequiredFeedInMeterError': 'Der Zählerstand ist nicht plausibel. Bitte fügen Sie ein Ablesefoto und einen Ablesehinweis hinzu.',
                'hintRequiredError': 'Ein Zählerstand ist nicht plausibel. Bitte geben Sie einen Ablesehinweis an.',
                'hintMinLengthWarning': 'Der Ablesehinweis sollte mindestens 5 Zeichen enthalten.',
                'imageAlwaysRequiredHint': 'Bitte fügen Sie ein Foto von Ihrem Zählerstand hinzu, um Ihr Ableseergebnis zu senden.',
                'imageAlwaysRequiredHint_other': 'Bitte fügen Sie Fotos von Ihren Zählerständen hinzu, um Ihre Ableseergebnisse zu senden.'
            },
            'plausibilityHints': {
                'readingValueGreaterThanMaximumValue': 'Messwert höher als erwartet',
                'readingValueLessThanMinimumValue': 'Messwert niedriger als erwartet',
            },
            'tooltips': {
                'readingValueGreaterThanMaximumValue' : 'Der Ablesewert ist größer als erwartet.',
                'readingValueLessThanMinimumValue' : 'Der Ablesewert ist kleiner als erwartet.',
            },
            'imageUploaded': 'Ablesefoto hinzugefügt',
            'notifications': {
                'imageFormatUnsupported': {
                    'title': 'Foto konnte nicht hinzugefügt werden',
                    'message': 'Das ausgewählte Dateiformat wird nicht unterstützt. Bitte wählen Sie ein anderes Foto aus.',
                },
            },
            'dialogs': {
              'meterRateTaskReadingImages': {
                  'title': 'Ablesefotos',
                  'closeButton': 'Schließen',
              }
            },
            'confirmRemoveImage': {
                'title': 'Ablesefoto entfernen?',
                'content': 'Das Foto wird entfernt und kann nicht wiederhergestellt werden.',
                'ok': 'Entfernen',
            },
            'buttons': {
                'uploadImage': 'Ablesefoto hinzufügen',
                'dropImage': 'Ablesefoto hier ablegen',
                'selectImageFromGallery': 'Ablesefoto aus Galerie auswählen',
                'removeImage': 'Ablesefoto entfernen',
                'send': 'Senden',
                'share': 'Teilen',
                'more': 'Weitere Aktionen',
                'resendMeterReading' : 'Zählerstand erneut mitteilen',
                'resendMeterReading_other' : 'Zählerstände erneut mitteilen'
            },
            'capturedValues': {
                'title': 'Kontaktdaten',
                'description': 'Für Rückfragen zur Ablesung. Die Angabe ist freiwillig.',
                'descriptionRequired': 'Für Rückfragen zur Ablesung.',
                'labels': {
                    'phone': 'Telefonnummer',
                    'phoneRegion': 'Land der Telefonnummer',
                    'otherRegion': 'Andere',
                    'email': 'E-Mail-Adresse',
                },
                'placeholders': {
                    'phone': 'z. B. 0123 456789',
                    'phoneInternational': 'z. B. +49 123 456789',
                    'email': 'z. B. name@example.com',
                },
                'warnings': {
                    'phoneInvalid': 'Diese Telefonnummer ist nicht gültig. Bitte prüfen Sie die Eingabe.',
                    'phoneCountryCodeMissing': 'Bitte beginnen Sie mit der Ländervorwahl, z. B. +49 oder 0049.',
                    'phoneRequired': 'Bitte erfassen Sie eine Telefonnummer.',
                    'emailInvalid': 'Diese E-Mail-Adresse ist ungültig.',
                    'emailRequired': 'Bitte erfassen Sie eine E-Mail-Adresse.',
                },
            },
        },
        'home': {
            'title': 'Übersicht: Ablesungen',
            'expireWarning': '<0>Achtung</0> am {{expireDate}} laufen {{expireCount}} Aufträge ab, die noch nicht abgelesen wurden!',
            'statistic': {
                'title': '$t(common.reading_other)',
                'total': 'Gesamt',
                'done': 'Erledigt',
            },
            'period': {
                'title': 'Zeiträume',
                'description': 'Damit die Verbräuche korrekt abgerechnet werden können, müssen die Zählerstände rechtzeitig an uns übermittelt werden. Hier sehen Sie die Zeiträume, bis wann wir Ihren Zählerstand benötigen:',
                'showMeters': 'Zähler anzeigen',
            },
        },
        'unknownMeterReading': {
            'listItemLabel': 'weiteren Zählerstand erfassen',
            'heading': 'Zählerstand für weiteren Zähler erfassen',
            'description': 'Gern können Sie Zählerstände für Zähler erfassen, welche nicht in dieser Ableseliste angefragt wurden. Diese zusätzlichen Stände werden nach der Erfassung direkt an <1>{{applicationName}}</1> weitergeleitet. Bitte beachten Sie, dass diese zusätzlich erfassten Stände nach der Weiterleitung hier nicht mehr angezeigt werden.',
            'loginDropdown': {
                'optionFallback': 'kein Bezeichner',
                'placeholder': 'Bitte wählen'
            },
            'notAllowedNotification': {
                'title': 'Nicht erlaubt',
                'message': 'Sie verfügen nicht über die benötigten Rechte für diese Funktion.'
            },
        },
    },
    'evaluation': {
        'hint': 'Wählen Sie im linken Menü einen Zähler aus, um dessen Auswertung anzuzeigen.',
        'labels': {
            'readingsNotDone': 'Nicht erledigte $t(common.reading_other)',
            'readingsWithoutEvaluation': 'Nicht auswertbar',
        },
        'details': {
            'title': 'Zählerauswertung',
            'labels': {
                'consumptions': 'Verbräuche',
                'history': 'Ablesehistorie',
                'meterAddress': 'Zähleranschrift',
                'consumption': 'Verbrauch',
                'comparisonToPreviousConsumption': 'Vergleich zum letzten Verbrauch',
            },
        },
        'empty': {
            'noJobs': 'Für die Auswertung liegen aktuell nicht genügend Daten vor.',
            'noReadingEventsForMeterRate': 'Für den Tarif {{rateName}} liegen keine Ableseergebnisse vor.',
            'noReadingEventsForMeterRates': 'Für die Tarife {{rateNames}} liegen keine Ableseergebnisse vor.',
            'noEvaluationPossibleWithRateName': 'Es kann keine Verbrauchsauswertung für den Tarif: {{rateName}} durchgeführt werden.',
            'noEvaluationPossibleNoRateName': 'Es kann keine Verbrauchsauswertung für diesen Tarif durchgeführt werden.',
        },
    },
    'management': {
        'hint': 'Wählen Sie im linken Menü einen Zugang aus, um Aufträge zu teilen.',
        'excelExport': {
            'selection': {
                'description': 'Bitte wählen Sie die Aufträge aus, die heruntergeladen werden sollen.',
                'notice': {
                    'label': 'Hinweis:',
                    'text': 'Für jede ausgewählte Gruppe wird eine separate Excel-Datei heruntergeladen.',
                },
            },
            'wizard': {
                'button': 'Aufträge herunterladen',
                'title': 'Aufträge herunterladen',
                'defaultGroupName': 'Aufträge',
                'steps': {
                    'selectJobs': 'Aufträge auswählen',
                    'chooseFormat': 'Format wählen',
                },
                'actions': {
                    'cancel': 'Abbrechen',
                    'next': 'Weiter',
                    'back': 'Zurück',
                    'export': 'Aufträge herunterladen',
                    'retry': 'Erneut versuchen',
                    'loading': 'Datei wird erstellt...',
                },
                'loadingOverlay': 'Datei wird erstellt...',
                'showExpiredJobs': 'Abgelaufene Aufträge anzeigen',
                'showDoneJobs': 'Erledigte Aufträge anzeigen',
                'errors': {
                    'exportFailed': 'Download fehlgeschlagen. Bitte versuchen Sie es erneut.',
                },
                'info': {
                    'autoFormat': 'Für die meisten Fälle empfohlen: Wir nehmen automatisch nur die Spalten auf, die sich zwischen Ihren ausgewählten Aufträgen unterscheiden. Angaben, die bei allen Aufträgen gleich sind, lassen wir weg – so bleibt die Datei übersichtlich. Sie müssen nichts weiter einstellen.',
                },
                'format': {
                    'groupLabel': 'Excel-Format',
                    'auto': 'Automatisch',
                    'moreFormats': 'Weitere Formate',
                    'custom': 'Benutzerdefiniert',
                    'customHint': 'Für volle Kontrolle: Die wichtigsten Ablesedaten sind immer dabei. Darüber hinaus entscheiden Sie selbst, welche zusätzlichen Informationen (z. B. Kunden-, Zähler- und Auftragsdaten) aufgenommen werden – ideal, um die Datei genau auf einen Empfänger zuzuschneiden.',
                },
            },
            'file': {
                'sheetName': 'Ableseliste',
                'status': {
                    'incomplete': 'Daten unvollständig',
                    'done': 'Ablesung erledigt',
                    'invalid': 'Daten ungültig',
                    'implausible': 'Zählerstand unplausibel',
                    'alreadyRead': 'Bereits abgelesen',
                },
            },
            'columns': {
                'groups': {
                    'meter': 'Zähler',
                    'reading': 'Ablesung',
                    'location': 'Zählpunkt',
                    'customer': 'Kunde',
                    'partner': 'Partner',
                    'tariff': 'Auftrag',
                    'history': 'Ablesungen',
                },
                'fields': {
                    'meterNumber': '$t(meterReadingJob.meterNumber)',
                    'obis': '$t(meterReadingJob.obisCode)',
                    'readingDate': '$t(meterReadingJob.readingDate)',
                    'readingValue': '$t(meterReadingJob.readingValue)',
                    'readingHint': '$t(meterReadingJob.address.hint)',
                    'status': '$t(meterReadingJob.status)',
                    'meterAddressStreet': '$t(meterReadingJob.address.street) und $t(meterReadingJob.address.houseNumber)',
                    'meterAddressZip': '$t(meterReadingJob.address.zip)',
                    'meterAddressCity': '$t(meterReadingJob.address.city) / $t(meterReadingJob.address.cityDistrict)',
                    'meterAddressObjectKey': '$t(meterReadingJob.objectKey)',
                    'meterAddressLocationDescription': '$t(meterReadingJob.address.locationDescription)',
                    'meterAddressLocationHint': 'Hinweis',
                    'customerNumber': '$t(meterReadingJob.customer.customernumber)',
                    'customerName': '$t(meterReadingJob.customer.name)',
                    'customerCompany': '$t(meterReadingJob.customer.company)',
                    'mailingAddressStreet': 'Straße und Hausnummer',
                    'mailingAddressZip': 'PLZ',
                    'mailingAddressCity': 'Stadt',
                    'mailingAddressPostbox': 'Postfach',
                    'email': 'E-Mail',
                    'phone': 'Telefon',
                    'mobile': 'Mobilnummer',
                    'partnerKey': '$t(meterReadingJob.partner.identifier)',
                    'partnerName': '$t(meterReadingJob.partner.name)',
                    'partnerCompany': '$t(meterReadingJob.partner.company)',
                    'partnerContractId': 'Vertrags-ID',
                    'tariffName': 'Tarifname',
                    'unit': 'Einheit',
                    'meterType': '$t(meterReadingJob.meterType)',
                    'maLoId': '$t(meterReadingJob.maLoId)',
                    'meloId': '$t(meterReadingJob.meLoId)',
                    'externalOrderId': 'Externe Auftrags-ID',
                    'validUntil': 'Gültig bis',
                    'executionDeadline': '$t(meterReadingJob.jobConstraints.latestExecution)',
                    'targetReadingDate': '$t(common.targetReadingDate)',
                    'lastReadingValue': 'Letzter Ablesewert',
                    'lastReadingDate': 'Letztes Ablesedatum',
                    'lastResultValue': 'Übermittelter Wert',
                    'lastResultDate': 'Erledigt am',
                },
                'excelFields': {
                    'customerNumber': 'Kunde: $t(meterReadingJob.customer.customernumber)',
                    'customerName': 'Kunde: $t(meterReadingJob.customer.name)',
                    'customerCompany': 'Kunde: $t(meterReadingJob.customer.company)',
                    'customerPostalAddress': 'Kunde: Anschrift',
                    'customerMailingAddressStreet': 'Kunde: Straße und Hausnummer',
                    'customerMailingAddressZip': 'Kunde: PLZ',
                    'customerMailingAddressCity': 'Kunde: Stadt',
                    'customerMailingAddressPostbox': 'Kunde: Postfach',
                    'customerContactEmail': 'Kunde: E-Mail',
                    'customerContactPhone': 'Kunde: Telefon',
                    'customerContactMobile': 'Kunde: Mobilnummer',
                    'partnerKey': '$t(meterReadingJob.partner.identifier)',
                    'partnerName': 'Partner: $t(meterReadingJob.partner.name)',
                    'partnerCompany': '$t(meterReadingJob.partner.company)',
                    'partnerContractId': 'Partner: Vertrags-ID',
                    'partnerMailingAddressStreet': 'Partner: Straße und Hausnummer',
                    'partnerMailingAddressZip': 'Partner: PLZ',
                    'partnerMailingAddressCity': 'Partner: Stadt',
                    'partnerMailingAddressPostbox': 'Partner: Postfach',
                    'partnerContactEmail': 'Partner: E-Mail',
                    'partnerContactPhone': 'Partner: Telefon',
                    'partnerContactMobile': 'Partner: Mobilnummer',
                    'meterAddressStreet': 'Zählpunkt: $t(meterReadingJob.address.street) und $t(meterReadingJob.address.houseNumber)',
                    'meterAddressZip': 'Zählpunkt: $t(meterReadingJob.address.zip)',
                    'meterAddressCity': 'Zählpunkt: $t(meterReadingJob.address.city) / $t(meterReadingJob.address.cityDistrict)',
                    'meterAddressObjectKey': 'Zählpunkt: $t(meterReadingJob.objectKey)',
                    'meterAddressLocationDescription': 'Zählpunkt: $t(meterReadingJob.address.locationDescription)',
                    'meterAddressLocationHint': 'Zählpunkt: Hinweis',
                    'externalOrderId': 'Externe Auftrags-ID',
                    'maLoId': '$t(meterReadingJob.maLoId)',
                    'meloId': '$t(meterReadingJob.meLoId)',
                    'meterType': '$t(meterReadingJob.meterType)',
                    'tariffName': 'Tarifname',
                    'unit': 'Einheit',
                    'executionDeadline': '$t(meterReadingJob.jobConstraints.latestExecution)',
                    'validUntil': 'Gültig bis',
                    'lastReadingDate': 'Letztes Ablesedatum',
                    'lastReadingValue': 'Letzter Ablesewert',
                    'lastResultDate': 'Erledigt am',
                    'lastResultValue': 'Übermittelter Wert',
                },
                'aria': {
                    'selectGroup': 'Alle Spalten aus "{{group}}" auswählen',
                    'collapseGroup': 'Gruppe einklappen',
                    'expandGroup': 'Gruppe ausklappen',
                },
            },
        },
        'accounts': {
            'title': 'Meine Zugänge',
            'reminder': {
              'subject': 'Erinnerung zur Ablesung',
              'body': 'Sehr geehrte/r {{name}},\n\n\nwir möchten Sie daran erinnern, Ihre Zählerstände im Ableseportal zu erfassen.\n\nUm zu Ihrem Ableseportal zu gelangen klicken Sie bitte auf den folgenden Link:\n\n{{login}}\n'
            },
            'labels': {
                'total': 'Gesamt',
            },
            'list': {
                'by': 'von',
            },
            'subaccounts': {
                'empty': 'Dieser Zugang hat keine Aufträge geteilt.',
                'buttons': {
                    'share': 'Aufträge teilen',
                    'shareShort': 'Teilen'
                },
                'overview': {
                    'title': 'Erstellte Zugänge',
                },
                'details': {
                    'openedByToken': 'Diese Freigabe wurde von Ihnen selbst erstellt. Hier sehen Sie die Aufträge, die darin enthalten sind.',
                    'description': 'Dieser Zugang enthält {{count}} Auftrag',
                    'description_other': 'Dieser Zugang enthält {{count}} Aufträge',
                    'delete': {
                        'confirm': {
                            'title': 'Freigabe wirklich löschen?',
                            'description': 'Die Freigabe wird gelöscht, Aufträge und Ergebnisse bleiben erhalten.',
                        },
                        'title': 'Ablesung aus Freigabe entfernen?',
                        'description': 'Die Ablesung wird <1>aus der Freigabe</1> entfernt. In Ihren Ablesungen bleibt sie weiterhin enthalten.',
                    },
                    'reshare': {
                        'title': 'Neue Zugangsdaten anlegen',
                        'description': 'Wollen Sie weitere Zugangsdaten anlegen? Der bestehende Zugang bleibt erhalten.',
                    },
                },
            },

            'share': {
                'quickShareInfo': {
                    'intro': 'Direkt teilen erstellt sofort diesen Zugang und verschickt die E-Mails:',
                    'accessName': 'Zugangsname:',
                    'nameFallback': '(kein Name)',
                    'reshareLabel': 'Weiterteilen:',
                    'reshareYes': 'erlaubt',
                    'reshareNo': 'nicht erlaubt',
                    'emailsLabel': 'E-Mails an:',
                    'noEmails': 'keine hinterlegt',
                    'moreEmails': '+{{count}} weitere',
                },
                'assignmentPresets': {
                    'label': 'Gespeicherte Vorauswahl:',
                    'meterChanged': 'Zählernummer weicht ab – möglicher Zählerwechsel',
                    'meterChangedLabel': 'anderer Zähler',
                    'meterChangedTitle': 'Zählernummer weicht ab',
                    'meterChangedTooltipIntro': 'Für die Messlokation {{meLoId}} ist heute eine andere Zählernummer hinterlegt als beim Anlegen der Vorauswahl.',
                    'meterChangedStoredLabel': 'Damals gespeichert',
                    'meterChangedCurrentLabel': 'Aktuell',
                    'meterChangedNotice': 'Einer der ausgewählten Aufträge hat einen anderen Zähler als beim Anlegen der Vorauswahl hinterlegt.',
                    'meterChangedNotice_other': '{{count}} der ausgewählten Aufträge haben einen anderen Zähler als beim Anlegen der Vorauswahl hinterlegt.',
                    'deleteConfirm': 'Gespeicherte Vorauswahl „{{name}}“ wirklich löschen?',
                    'deleteLabel': 'Gespeicherte Vorauswahl löschen',
                    'selectPlaceholder': 'Vorauswahl wählen',
                    'resetLabel': 'Vorauswahl zurücksetzen',
                    'deleteConfirmOk': 'Löschen',
                },
                'title': 'Aufträge teilen',
                'task': 'Auftrag',
                'task_other': 'Aufträge',
                'buttons': {
                    'share': '{{count}} Auftrag teilen',
                    'share_other': '{{count}} Aufträge teilen',
                    'shareStepByStep': 'Schritt für Schritt teilen',
                    'quickShare': '{{count}} Auftrag direkt teilen & E-Mails senden',
                    'quickShare_other': '{{count}} Aufträge direkt teilen & E-Mails senden',
                    'quickShareNoEmails': 'Im Preset sind keine E-Mails hinterlegt',
                },
                'error': {
                  'maxjobs': 'Es können maximal {{count}} Aufträge geteilt werden.'
                },
                'loading': 'Aufträge werden geladen...',
                'labels': {
                    // 'status',
                },
                'empty': 'Sie haben keine Aufträge, die Sie (weiter)teilen dürfen',
                'description': 'Bitte wählen Sie die Aufträge, die geteilt werden sollen.',
                'hint': '<0>Tipp:</0> Klicken Sie auf die Spalten-Namen um die Tabelle zu sortieren. Mit einem Klick auf <3/> können Sie Aufträge gruppieren.',
                'hintSortOnly': '<0>Tipp:</0> Klicken Sie auf die Spalten-Namen um die Tabelle zu sortieren.',
                'tableColumns': {
                    'isShared': "Geteilt",
                    'allHidden': 'Für diese Tabelle sind alle Spalten ausgeblendet.',
                },
                'exportXlsx': {
                    'title': 'Ablesungen als Excel-Datei herunterladen',
                    'description': 'Bei Bedarf können Sie die ausgewählten Ableseaufträge als Excel-Datei herunterladen.',
                    'label': 'Datei herunterladen',
                    'button': 'Excel-Datei herunterladen',
                    'headers': {
                        'partnerIdentifier': '$t(meterReadingJob.partner.identifier)',
                        'partnerCompany': '$t(meterReadingJob.partner.company)',
                        'customerNumber': '$t(meterReadingJob.customer.customernumber)',
                        'customerCompany': '$t(meterReadingJob.customer.company) GP',
                        'customerMailingAddressStreet': '$t(meterReadingJob.address.street) GP',
                        'customerMailingAddressHouseNumber': '$t(meterReadingJob.address.houseNumber) GP',
                        'customerMailingAddressZip': '$t(meterReadingJob.address.zip) GP',
                        'customerMailingAddressCity': '$t(meterReadingJob.address.city) GP',
                        'maLoId': '$t(meterReadingJob.maLoId)',
                        'meterAddressStreet': 'Verbrauchsstelle $t(meterReadingJob.address.street)',
                        'meterAddressHouseNumber': 'Verbrauchsstelle $t(meterReadingJob.address.houseNumber)',
                        'meterAddressZip': 'Verbrauchsstelle $t(meterReadingJob.address.zip)',
                        'meterAddressCity': 'Verbrauchsstelle $t(meterReadingJob.address.city)',
                        'meterAddressObjectKey': 'Verbrauchsstelle $t(meterReadingJob.objectKey)',
                        'meterAddressLocationDescription': 'Verbrauchsstelle $t(meterReadingJob.address.locationDescription)',
                        'meterAddressHint': '$t(meterReadingJob.address.hint)',
                        'lastMeterReadingDate': 'letztes Ablesedatum',
                        'lastMeterReadingValue': 'letzter Ablesewert',
                        'meterReadingDate': '$t(meterReadingJob.readingDate)',
                        'meterReadingValue': '$t(meterReadingJob.readingValue)',
                        'meterNumber': '$t(meterReadingJob.meterNumber)',
                        'meterType': '$t(meterReadingJob.meterType)',
                        'rateName': '$t(meterReadingJob.rates)',
                        'obis': '$t(meterReadingJob.obisCode)',
                        'targetReadingDate': '$t(common.targetReadingDate)',
                        'latestExecution': '$t(meterReadingJob.jobConstraints.latestExecution)',
                    },
                    'error' : {
                        'title': 'Excel-Download Fehler',
                        'message': 'Beim Herunterladen der Excel-Daten ist ein Fehler aufgetreten, bitte versuchen Sie es später erneut.'
                    }
                },
            },
        },
        'import': {
            'button': 'Zählerstände übermitteln',
            'wizardSteps': {
                'fileSelect': 'Datei wählen',
                'review': 'Zählerstände prüfen',
                'summary': 'Zusammenfassung',
            },
            'fileSelect': {
                'title': 'Zählerstände übermitteln',
                'dropzone': 'Datei hier ablegen oder auswählen',
                'button': 'Datei auswählen',
                'error': 'Datei konnte nicht gelesen werden',
                'formatHint': 'Nur .xlsx-Dateien werden unterstützt',
                'analyzing': 'Datei wird analysiert...',
                'noJobsError': 'Keine Aufträge geladen. Bitte Seite neu laden.',
            },
            'plausible': {
                'body': 'Es wurde {{count}} neuer, plausibler Zählerstand erkannt.',
                'body_other': 'Es wurden {{count}} neue, plausible Zählerstände erkannt.',
                'otherSkipped': '{{count}} weiterer Zählerstand wird in den nächsten Schritten berücksichtigt.',
                'otherSkipped_other': '{{count}} weitere Zählerstände werden in den nächsten Schritten berücksichtigt.',
            },
            'warning': {
                'title': 'Unplausible Zählerstände',
                'body': 'Es wurde {{count}} unplausibler Zählerstand erkannt. Möchten Sie diesen ohne Prüfung übermitteln? (nicht empfohlen)',
                'body_other': 'Es wurden {{count}} unplausible Zählerstände erkannt. Möchten Sie diese ohne Prüfung übermitteln? (nicht empfohlen)',
            },
            'review': {
                'progress': 'Zählerstand {{current}} von {{total}} prüfen',
                'tariffLabel': 'Tarif',
                'readingDateLabel': 'Ablesedatum',
                'readingValueLabel': 'Ablesewert',
                'commentLabel': 'Ablesehinweis',
                'photoLabel': 'Ablesefoto hinzufügen',
                'alreadyDoneHint': 'Bereits übermittelt – wird nicht erneut gesendet.',
                'noValueHint': 'Nicht ausgefüllt – bleibt offen und kann später abgelesen werden.',
                'plausibleHint': 'Plausibler Ablesewert',
                'plausibleOnlyConfirm': {
                    'title': 'Nur plausible Zählerstände senden?',
                    'content': 'Unplausible Zählerstände werden nicht gesendet.',
                    'confirm': 'Nur plausible senden & weiter',
                },
                'skipAllHint': 'Alle nicht senden: Die aktuell angezeigten und alle folgenden zu prüfenden Zählerstände werden nicht gesendet. Bereits gesendete Zählerstände bleiben unverändert.',
            },
            'summary': {
                'resultTitle': 'Neuer Zählerstand erfolgreich übermittelt',
                'resultTitle_other': 'Neue Zählerstände erfolgreich übermittelt',
                'resultTitleAllDone': 'Zählerstand erfolgreich übermittelt',
                'resultTitleAllDone_other': 'Alle Zählerstände erfolgreich übermittelt',
                'resultTitleNone': 'Keine neuen Zählerstände übermittelt',
                'reDownloadHint': 'Für die nicht übermittelten Zählerstände können Sie die betroffenen Aufträge erneut herunterladen und die Werte bei Bedarf anschließend erneut übermitteln.',
                'submittedPlausible': 'Automatisch als plausibel erkannt und übermittelt',
                'submittedImplausible': 'Nach manueller Prüfung freigegeben und übermittelt',
                'notImportedSummary': 'Nicht übermittelt – z. B. bewusst übersprungen oder mit einem Problem in den Daten.',
                'reason': {
                    'alreadyDone': 'Bereits übermittelt – nicht erneut gesendet',
                },
                'skippedFiles': '{{count}} Datei nicht verarbeitet (kein .xlsx)',
                'skippedFiles_other': '{{count}} Dateien nicht verarbeitet (kein .xlsx)',
                'reExportButton': 'Aufträge erneut herunterladen',
                'reExportFileSuffix': 'Prüfung',
                'reExportError': {
                    'title': 'Erneuter Download fehlgeschlagen',
                    'message': 'Die Datei konnte nicht erstellt werden. Bitte versuchen Sie es erneut.',
                },
            },
            'actions': {
                'import': 'Senden & weiter',
                'skip': 'Nicht senden & weiter',
                'skipAll': 'Alle nicht senden',
                'cancel': 'Abbrechen',
                'importAll': 'Alle ohne Prüfung senden & weiter',
                'review': 'Zählerstände prüfen',
                'close': 'Schließen',
                'importMore': 'Weitere Datei importieren',
            },
        },
    },
    'help': {
        'global': {
            'contentTitle': 'Ableseportal - Hilfe',
            'tableOfContents': 'Inhaltsverzeichnis',
            'defaultText': 'Die Hilfe ist in der gewählten Sprache nicht verfügbar.',
            'offlineText': 'Offline ist die Hilfe nicht verfügbar.',
            'errorText': 'Die Hilfe ist momentan nicht verfügbar.',
            'backToTop': 'Nach oben',
        },
        'sidePopOver': {
            'title': 'Hilfe zur Ablesung',
            'button': 'Hilfe',
        },
    },
    'communication': {
        'triggerButton': {
            'registration': 'Hier Anmelden',
            'communication': 'Ablesebestätigung zusenden',
        },
        'home': {
            'title': 'Digitale & papierlose Kommunikation',
            'registration': {
                'description': 'Stellen Sie auf digitale Kommunikation um. Das schont die Umwelt und spart Zeit. Außerdem geht alles schneller und Sie behalten den Überblick.',
                'descriptionBulletPointsTitle': 'Ihre Vorteile:',
                'descriptionBulletPoints': [
                    'Bestätigung zur erfolgten Ablesung per E-Mail',
                    'Zusammenstellung aller Informationen zu Ihrer Ablesung',
                    'Zukünftig schnelle und unkomplizierte Mitteilungen per E-Mail',
                ],
            },
            'communication': {
                'description': 'Sie sind für die digitale Kommunikation angemeldet und können die Ablesebestätigung per E-Mail anfordern.',
            }
        },
        'jobDetails': {
            'title': 'Digitale Kommunikation',
            'registration': {
                'description': 'Stellen Sie auf digitale Kommunikation um. Das schont die Umwelt und spart Zeit. Außerdem geht alles schneller und Sie behalten den Überblick.',
            },
            'communication': {
                'description': 'Sie sind für die digitale Kommunikation angemeldet und können die Ablesebestätigung per E-Mail anfordern.',
            }
        },
        'dialog': {
            'registration': {
                'title': 'Anmeldung zur digitalen & papierlosen Kommunikation',
                'description': 'Um die Ablesebestätigung per E-Mail zu erhalten, melden Sie sich bitte für die digitale Kommunikation an.',
                'content': 'Erhalten Sie Ihre abgelesenen Zählerstände bequem per E-Mail. Ihre Kommunikationseinstellungen können Sie bei Bedarf jederzeit anpassen.',
                'missingURL': 'Die Anmeldung zur digitalen Kommunikation ist aktuell nicht möglich. Bitte versuchen Sie es später erneut.',
                'submitButtonText': 'Anmelden',
                'cancelButtonText': 'Abbrechen',
            },
            'communication': {
                'title': 'Ablesebestätigung per E-Mail erhalten',
                'description': 'Sie sind bereits für die digitale Kommunikation angemeldet. Sie können die Ablesebestätigungen per E-Mail hier anfordern.',
                'content': 'Der Versand der Ablesebestätigung per E-Mail ist für Sie kostenfrei. Sie haben einen Zähler abgelesen. Möchten Sie eine Ablesebestätigung per E-Mail anfordern?',
                'content_other': 'Der Versand der Ablesebestätigung per E-Mail ist für Sie kostenfrei. Sie haben bereits {{count}} Zähler abgelesen. Möchten Sie eine Ablesebestätigung per E-Mail anfordern?',
                'submitButtonText': 'Ablesebestätigung anfordern',
                'cancelButtonText': 'Abbrechen',
            }
        },
        'notification': {
            'registration': {
                'done': {
                    'title': 'Erfolgreich zur digitalen Kommunikation angemeldet',
                    'description': 'Ab sofort können Sie sich eine Ablesebestätigung per E-Mail zusenden lassen, nachdem Sie einen Zähler abgelesen haben.'
                }
            },
            'communication': {
                'done': {
                    'title': 'Bestätigung ist unterwegs',
                    'description': 'Wir haben Ihnen die Bestätigung Ihrer Ablesung per E-Mail geschickt.',
                    'description_other': 'Wir haben Ihnen die Bestätigung Ihrer {{count}} Ablesungen per E-Mail geschickt.',
                },
                'error': {
                    'title': 'Anfrage für Ablesebestätigung fehlgeschlagen',
                    'description': 'Der Versand der Ablesebestätigung per E-Mail für einen Zähler konnte nicht ausgeführt werden. Bitte versuchen Sie es später erneut.',
                    'description_other': 'Der Versand der Ablesebestätigung per E-Mail für {{count}} Zähler konnte nicht ausgeführt werden. Bitte versuchen Sie es später erneut.',
                }
            }
        }
    },
    'meterReadingJob': {
        'type': 'Typ',
        'status': 'Status',
        'meter': 'Zähler',
        'meLoId': 'Messlokation',
        'maLoId': 'Marktlokation',
        'meterNumber': 'Zählernummer',
        'meterType': 'Zählerart',
        'rates': 'Tarife',
        'obisCode': 'OBIS',
        'objectKey': 'Objekt',
        'readingDate': 'Ablesedatum',
        'readingValue': 'Ablesewert',
        'customer': {
            'title': 'Kunde',
            'customernumber': 'Kundennummer',
            'company': 'Firma',
            'name': 'Name',
            'summary': 'Kunde, zusammengefasst',
            'firstname': 'Vorname',
            'lastname': 'Nachname',
        },
        'partner': {
            'title': 'Partner',
            'identifier': 'Partner-Nr.',
            'company': 'Partner-Firma',
            'name': 'Name',
            'firstname': 'Partner-Vorname',
            'lastname': 'Partner-Nachname',
        },
        'jobConstraints': {
            'earliestExecution': 'Ablesung ab',
            'latestExecution': 'Ablesefrist',
        },
        'address': {
            'title': 'Adresse',
            'fullAddress': 'Zähleranschrift',
            'name': 'Anschrift-Name',
            'company': 'Anschrift-Firma',
            'firstname': 'Anschrift-Vorname',
            'lastname': 'Anschrift-Nachname',
            'street': 'Straße',
            'houseNumber': 'Hausnummer',
            'zip': 'PLZ',
            'city': 'Stadt',
            'cityDistrict': 'Stadtteil',
            'hint': 'Ablesehinweis',
            'locationDescription': 'Beschreibung',
        },
        'aggregation': {
            'street': '{{count}} Straße',
            'street_other': '{{count}} Straßen',
            'zip': '{{count}} PLZ',
            'zip_other': '{{count}} PLZ',
            'city': '{{count}} Stadt',
            'city_other': '{{count}} Städte',
            'cityDistrict': '{{count}} Stadtteil',
            'cityDistrict_other': '{{count}} Stadtteile',
            'customernumber': '{{count}} KdNr',
            'customernumber_other': '{{count}} Kdnr',
            'objectKey': '{{count}} Objekt',
            'objectKey_other': '{{count}} Objekte',
            'meter': '{{count}} Zähler',
            'meter_other': '{{count}} Zähler',
            'latestExecution': '{{count}} Ablesefrist',
            'latestExecution_other': '{{count}} Ablesefristen',
        },
    },
    'offline': {
        'warning': 'Bitte schließen Sie Ihren Browser und diesen Tab nicht!',
        'description' : 'Ihre Ablesung kann momentan nicht gesendet werden. Sobald eine Verbindung besteht, werden die Aufträge nachträglich gesendet.',
        'details': 'Sie können weitere Ablesungen durchführen. Sobald Ihr Gerät wieder über eine Internetverbindung verfügt, werden alle Ablesungen gesendet.\n\n\nNoch nicht gesendete Ablesungen werden in einem Statusfenster angezeigt.',
        'infopanel' : {
            'message' : '{{queueLength}} Ablesung wurde noch nicht gesendet',
            'message_other' : '{{queueLength}} Ablesungen wurden noch nicht gesendet',
            'messageOnline' : '{{queueLength}} Ablesung wird noch gesendet',
            'messageOnline_other' : '{{queueLength}} Ablesungen werden noch gesendet',
            'messageMobile' : 'Sie sind offline. {{queueLength}} Ablesung noch nicht gesendet.',
            'messageMobile_other' : 'Sie sind offline. {{queueLength}} Ablesungen noch nicht gesendet.',
            'messageMobileOnline' : '{{queueLength}} Ablesung wird noch gesendet',
            'messageMobileOnline_other' : '{{queueLength}} Ablesungen werden noch gesendet',
            'details' : 'Die Aufträge werden gesendet, sobald eine Internetverbindung besteht.'
        },
        'buttons' : {
            'close': 'Hinweis ausblenden',
            'retry': 'Erneut versuchen'
        }
    },
    'menu': {
        'home': 'Startseite',
        'reading': 'Ablesung',
        'evaluation': 'Auswertung',
        'management': 'Verwaltung',
        'help': 'Hilfe',
        'accounts': 'Meine Zugänge',
        'logout': 'Abmelden',
    },
    'common': {
        'close': 'Schließen',
        'metertypes': {
            'ELECTRIC_METER': 'Stromzähler',
            'HEAT_METER': 'Wärmemengenzähler',
            'GAS_METER': 'Gaszähler',
            'WATER_METER': 'Wasserzähler',
            'WATER_WARM_METER': 'Warmwasserzähler',
            'GENERIC_METER': 'allg. Zähler',
        },
        'reasons': {
            'INITIAL_READING': 'Einbauzählerstand',
            'PERIODIC_READING': 'Turnusablesung',
            'ESTIMATED_READING': 'Schätzung',
            'INTERMEDIATE_READING': 'Zwischenablesung',
            'METER_CHANGE': 'Zählerwechsel',
            'OTHER': 'andere Ablesung',
            'OTHER_KSA': 'Kundenselbstablesung',
            'null': 'Unbekannter Grund'
        },
        'jobs': '{{count}} Auftrag',
        'jobs_other': '{{count}} Aufträge',
        'reading': 'Ablesung',
        'reading_other': 'Ablesungen',
        'progress': 'Fortschritt',
        'targetReadingDate': 'Zielablesedatum',
        'loadingReadings': 'Lade Ablesungen...',
        'loadingJobs': 'Lade Aufträge...',
        'search': 'Suche',
        'total': 'Gesamt',
        'until': 'bis',
        'of': 'von',
        'loading': 'wird geladen...',
        'dataPrivacy': 'Datenschutzbestimmungen',
        'imprint': 'Impressum',
        'dialog': {
            'ok': 'OK',
            'abort': 'Abbrechen',
        },
        'requiredField': 'Pflichtfeld',
        'fillRequiredFields': 'Bitte Pflichtfelder (*) angeben.',
        'account': {
            'noName': 'Mein Zugang',
        },
        'day': 'Tag',
        'highContrastOn': 'Hohen Kontrast einschalten',
        'highContrastOff': 'Hohen Kontrast ausschalten',
        'changeLanguageTo': 'Sprache zu {{language}} wechseln',
        'selectReadingDate': 'Ablesedatum wählen',
        'grouping': {
            'emptyValue': 'Ohne Angabe',
        },
    },
    'ai': {
        'cameraDialogDetails': {
            'loading': 'wird verarbeitet...',
            'hint': 'Bitte platzieren Sie Ihren Zähler innerhalb des Rahmens.',
        },
        'readingValueDetectedDialogDetails': {
            'hint': 'Ist der angezeigte Zählerstand korrekt?',
            'imageLabel': 'Zählerstand erkannt'
        },
        'meterRateDetectedDialogDetails': {
            'hint': 'Bitte geben Sie Ihren Zählerstand ein.',
            'imageLabel': 'Display erkannt',
        },
        'noResultDialogDetails': {
            'hint': 'Ist der Zählerstand und die Zählernummer auf dem Foto zu erkennen?',
            'imageLabel': 'Vorschau'
        },
        'invalidMediumOutcome': {
            'title': 'Falscher Zähler?',
            'description': 'Bitte prüfen Sie, ob Sie den richtigen Zähler fotografiert haben.',
            'expectedLabel': 'Erwarteter Zählertyp:',
            'detectedLabel': 'Zählertyp aus Foto:',
        },
        'invalidMeterNumberOutcome': {
            'title': 'Falscher Zähler?',
            'description': 'Bitte prüfen Sie, ob Sie den richtigen Zähler fotografiert haben.',
            'expectedLabel': 'Erwartete Zählernummer:',
            'detectedLabel': 'Zählernummer aus Foto:',
        },
        'invalidObisOutcome': {
            'title': 'Falscher Tarif?',
            'description': 'Bitte prüfen Sie, ob Sie den richtigen Tarif fotografiert haben.',
            'expectedLabel': 'Erwarteter Tarif:',
            'detectedLabel': 'Tarif aus Foto:',
        },
        'gallery': {
            'noResultDialogDetails': {
                'hint': 'Ist der Zählerstand und die Zählernummer auf dem ausgewählten Foto zu erkennen?',
                'imageLabel': 'Vorschau'
            },
            'invalidMediumOutcome': {
                'title': 'Falscher Zähler?',
                'description': 'Bitte prüfen Sie, ob Sie das richtige Foto ausgewählt haben.',
                'expectedLabel': 'Erwarteter Zählertyp:',
                'detectedLabel': 'Zählertyp aus Foto:',
            },
            'invalidMeterNumberOutcome': {
                'title': 'Falscher Zähler?',
                'description': 'Bitte prüfen Sie, ob Sie das richtige Foto ausgewählt haben.',
                'expectedLabel': 'Erwartete Zählernummer:',
                'detectedLabel': 'Zählernummer aus Foto:',
            },
            'invalidObisOutcome': {
                'title': 'Falscher Tarif?',
                'description': 'Bitte prüfen Sie, ob Sie das richtige Foto ausgewählt haben.',
                'expectedLabel': 'Erwarteter Tarif:',
                'detectedLabel': 'Tarif aus Foto:',
            },
            'buttons': {
                'retakeImage': 'Foto erneut auswählen',
                'takeImage': 'Foto übernehmen',
            },
        },
        'noPermissionDialog': {
            'title': 'Kamera ist blockiert',
            'description': 'Bitte erlauben Sie den Kamerazugriff in den Website-Einstellungen Ihres Browsers, um den vollen Funktionsumfang zu nutzen und versuchen Sie es erneut.',
            'iosHint': 'Öffnen Sie auf Ihrem iPhone oder iPad die Einstellungen → Apps → [Ihr Browser] → Kamera und wählen Sie „Zulassen“.',
            'androidHint': 'Öffnen Sie auf Ihrem Android-Gerät das Browser-Menü (⋮) → Website-Einstellungen → Kamera und stellen Sie die Berechtigung auf „Zulassen“.',
            'hint': 'Alternativ können Sie ein Foto aus Ihrer Galerie wählen.',
            'confirmButtonText': 'Weiter ohne Zugriff',
            'cancelButtonText': 'Abbrechen',
        },
        'buttons': {
            'confirm': 'Bestätigen',
            'cancel': 'Abbrechen',
            'retakeImage': 'Neues Foto aufnehmen',
            'takeImage': 'Foto übernehmen',
            'forceObis': 'Für {{obis}} übernehmen'
        },
        'common': {
            'readingValue': 'Zählerstand',
            'title': 'Ablesefoto'
        }
    },
    'aiReading': {
        'title': 'Ablese-Assistent',
        'stepIndicator': 'Schritt {{step}} von {{total}}',
        'degradedHint': 'Vereinfachte Darstellung aktiv – die Erkennung läuft weiter.',
        'alignment': {
            'noMeter': 'Richten Sie die Kamera auf Ihren Zähler',
            'moveLeft': 'Kamera etwas nach links',
            'moveRight': 'Kamera etwas nach rechts',
            'moveUp': 'Kamera etwas nach oben',
            'moveDown': 'Kamera etwas nach unten',
            'moveCloser': 'Gehen Sie näher heran',
            'moveBack': 'Gehen Sie etwas zurück',
            'holdStill': 'Perfekt – ruhig halten!',
        },
        'progress': {
            'registers': '{{captured}} von {{total}} Zählerständen erfasst',
        },
        'overlay': {
            'checking': 'wird geprüft…',
        },
        'medium': {
            'ELECTRICITY': 'Stromzähler',
            'GAS': 'Gaszähler',
            'WATER': 'Wasserzähler',
            'WATER_WARM': 'Warmwasserzähler',
            'HEAT': 'Wärmezähler',
            'ABSTRACT': 'Zähler',
        },
        'instructions': {
            'consent': 'Für die geführte Ablesung wird Ihr Kamerabild zur Erkennung an unseren Server übertragen. Es werden nur Bilder Ihres Zählers verarbeitet.',
            'cameraPermission': 'Bitte erlauben Sie den Zugriff auf Ihre Kamera.',
            'permissionDenied': 'Kein Kamerazugriff möglich. Sie können den Zählerstand manuell eingeben.',
            'framing': 'Richten Sie die Kamera auf Ihren Zähler.',
            'identify': 'Platzieren Sie den Zähler im hellen Rahmen und halten Sie die Kamera ruhig.',
            'candidates': 'Mehrere Zählernummern erkannt. Bitte wählen Sie Ihren Zähler aus.',
            'noMatch': 'Der Zähler konnte keinem Ihrer Aufträge zugeordnet werden.',
            'noMatchWrongMedium': 'Es wurde ein {{medium}} erkannt – dafür gibt es in Ihrem Zugang keinen Ableseauftrag.',
            'noMatchNumber': 'Die Zählernummer {{number}} passt zu keinem Ihrer Aufträge. Stehen Sie vielleicht vor einem anderen Zähler?',
            'noMatchNumberSpoken': 'Die erkannte Zählernummer passt zu keinem Ihrer Aufträge. Stehen Sie vielleicht vor einem anderen Zähler?',
            'tariffs': 'Der Zählerstand wird gelesen. Bitte halten Sie die Kamera ruhig.',
            'tariffs_other': 'Die Zählerstände werden gelesen. Bitte halten Sie die Kamera ruhig.',
            'read': 'Halten Sie die Kamera ruhig auf das Zählwerk.',
            'confirm': 'Bitte prüfen und bestätigen Sie den erkannten Zählerstand.',
            'confirm_other': 'Bitte prüfen und bestätigen Sie die erkannten Zählerstände.',
            'done': 'Vielen Dank! Ihre Ablesung wurde übermittelt.',
            'offline': 'Keine Internetverbindung. Für die Ablesung mit dem Assistenten wird eine aktive Internetverbindung benötigt.',
            'framingTimeout': 'Es wurde kein Zähler erkannt. Bitte richten Sie die Kamera direkt auf den Zähler und achten Sie auf ausreichend Licht.',
        },
        'feedback': {
            'meterMatched': 'Zähler erkannt!',
            'multipleRegisters': 'Dieser Zähler hat {{total}} Tarife.',
            'registerCaptured': 'Wert {{captured}} von {{total}} erfasst – bitte weiter ruhig halten.',
            'allValuesCaptured': 'Alle Werte erfasst.',
        },
        'stuck': {
            'title': 'Ablesung nicht vollständig',
            'description': 'Einige Werte lassen sich gerade nicht sicher erkennen. Sie können im Auftrag manuell fortfahren.',
        },
        'framingTimeout': {
            'title': 'Kein Zähler gefunden',
        },
        'offline': {
            'title': 'Keine Internetverbindung',
            'description': 'Für die Ablesung mit dem Assistenten wird eine aktive Internetverbindung benötigt. Bitte prüfen Sie Ihre Verbindung und versuchen Sie es erneut.',
        },
        'buttons': {
            'start': 'Ablese-Assistent starten',
            'startAssistant': 'Ablese-Assistent starten',
            'mute': 'Ton aus',
            'unmute': 'Ton an',
            'confirmAll': 'Zählerstand bestätigen',
            'confirmAll_other': 'Zählerstände bestätigen',
            'retry': 'Erneut versuchen',
            'nextMeter': 'Weiteren Zähler erfassen',
            'manualCapture': 'Manuell erfassen',
            'continueInJob': 'Im Auftrag fortfahren',
            'keepTrying': 'Weiter versuchen',
            'exit': 'Assistent beenden',
            'manualEntry': 'Manuell eingeben',
            'close': 'Schließen',
            'next': 'Weiter',
            'back': 'Zurück',
        },
        'consent': {
            'title': 'Ablese-Assistent starten',
            'privacyHint': 'Hinweise zum Datenschutz finden Sie in unserer Datenschutzerklärung.',
            'audioLabel': 'Hinweise per Sprachausgabe vorlesen',
        },
        'done': {
            'title': 'Ablesung übermittelt',
            'moreOpen': 'Sie haben noch offene Ablesungen.',
            'allDone': 'Alle Ihre Ablesungen sind erledigt!',
        },
        'notFound': {
            'title': 'Zähler nicht erkannt',
            'titleWrongMedium': 'Falscher Zählertyp?',
            'titleNumberMismatch': 'Zählernummer passt nicht',
        },
        'candidates': {
            'title': 'Welche Zählernummer ist Ihre?',
        },
        'confirmPanel': {
            'title': 'Erkannter Zählerstand',
            'title_other': 'Erkannte Zählerstände',
            'stepIndicator': 'Tarif {{index}} von {{total}}',
            'unconfirmed': 'Dieser Wert wurde nur einmal erkannt. Bitte prüfen Sie ihn besonders sorgfältig.',
        },
    },
};
